import { z } from "zod";
import {
  SOCIAL_EXTRACTION_STATUS,
  type SocialExtractionStatus,
} from "./social";

/** Why one Actor dataset item never became a capture. */
export const SOCIAL_REJECT_REASONS = [
  "parse_failed",
  "handle_mismatch",
  "account_mismatch",
  "text_too_long",
  "media_download_failed",
] as const;
export const SOCIAL_REJECT_REASON = {
  PARSE_FAILED: "parse_failed",
  HANDLE_MISMATCH: "handle_mismatch",
  ACCOUNT_MISMATCH: "account_mismatch",
  TEXT_TOO_LONG: "text_too_long",
  MEDIA_DOWNLOAD_FAILED: "media_download_failed",
} as const satisfies Record<string, SocialRejectReason>;
export const SocialRejectReasonSchema = z.enum(SOCIAL_REJECT_REASONS);
export type SocialRejectReason = z.infer<typeof SocialRejectReasonSchema>;

/** Statuses a run occupies while it still owns, or may still start, paid work. */
export const SOCIAL_ACTIVE_EXTRACTION_STATUSES = [
  SOCIAL_EXTRACTION_STATUS.QUEUED,
  SOCIAL_EXTRACTION_STATUS.STARTING,
  SOCIAL_EXTRACTION_STATUS.RUNNING,
  SOCIAL_EXTRACTION_STATUS.IMPORTING,
  SOCIAL_EXTRACTION_STATUS.STOPPING,
] as const;

const ACTIVE = new Set<SocialExtractionStatus>(
  SOCIAL_ACTIVE_EXTRACTION_STATUSES,
);

/** Whether the extraction still owns, or may still start, paid work. */
export function isActiveExtractionStatus(
  status: SocialExtractionStatus,
): boolean {
  return ACTIVE.has(status);
}
